import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import RequireAuth from "components/hoc/RequireAuth";
import Login from "./Login";
import Dashboard from "./Dashboard/index";
import Manage from "./Manage/index";
import Metadata from "./Metadata";
import MetadataAdd from "./Metadata/Add";
import MetadataEdit from "./Metadata/Edit";
import Departments from "./Departments";
import DepartmentAdd from "./Departments/Add";
import DepartmentEdit from "./Departments/Edit";
import Roles from "./Roles";
import RoleAdd from "./Roles/Add";
import RoleEdit from "./Roles/Edit";
import Clients from "./Clients";
import ClientAdd from "./Clients/Add";
import ClientEdit from "./Clients/Edit";
import Teams from "./Teams";
import TeamAdd from "./Teams/Add";
import TeamEdit from "./Teams/Edit";
import Users from "./Users";
import FileHistory from "./FileHistory";
import UserAdd from "./Users/Add";
import UserEdit from "./Users/Edit";
import UserChangePassword from "./Users/ChangePassword";
import Workflows from "./Workflows";
import WorkflowAdd from "./Workflows/Add";
import WorkflowEdit from "./Workflows/Edit";
import Uploads from "./Uploads";
import Accuracy from "components/Accuracy";
import DeletedFileLogs from "./DeletedFileLogs";
import ImportedFileLogs from "./ImportedFileLogs";
import AiCredentials from "./Ai";
import AiForm from "./Ai/Form";

export default function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/dashboard" component={RequireAuth(Dashboard)} />
        {/* Accuracy */}
        <Route exact path="/accuracy" component={RequireAuth(Accuracy)} />
        {/* Metadata */}
        <Route
          path="/manage/metadata/add"
          component={RequireAuth(MetadataAdd)}
        />
        <Route
          path="/manage/metadata/edit/:metadataId"
          component={RequireAuth(MetadataEdit)}
        />
        <Route path="/manage/metadata" component={RequireAuth(Metadata)} />
        {/* Departments */}
        <Route
          path="/manage/departments/add"
          component={RequireAuth(DepartmentAdd)}
        />
        <Route
          path="/manage/departments/edit/:departmentId"
          component={RequireAuth(DepartmentEdit)}
        />
        <Route
          path="/manage/departments"
          component={RequireAuth(Departments)}
        />
        {/* Roles */}
        <Route path="/manage/roles/add" component={RequireAuth(RoleAdd)} />
        <Route
          path="/manage/roles/edit/:roleId"
          component={RequireAuth(RoleEdit)}
        />
        <Route path="/manage/roles" component={RequireAuth(Roles)} />
        {/* Teams */}
        <Route
          path="/manage/clients/:clientId/teams/add"
          component={RequireAuth(TeamAdd)}
        />
        <Route
          path="/manage/clients/:clientId/teams/edit/:teamId"
          component={RequireAuth(TeamEdit)}
        />
        <Route
          path="/manage/clients/:clientId/teams/manage"
          component={RequireAuth(Teams)}
        />
        {/* Users */}
        <Route path="/manage/users/add" component={RequireAuth(UserAdd)} />
        <Route
          path="/manage/users/edit/:userId/password"
          component={RequireAuth(UserChangePassword)}
        />
        <Route
          path="/manage/users/edit/:userId"
          component={RequireAuth(UserEdit)}
        />
        <Route path="/manage/users" component={RequireAuth(Users)} />
        {/* File History */}
        <Route
          path="/manage/file-history"
          component={RequireAuth(FileHistory)}
        />
        {/* Deleted File Logs */}
        <Route
          path="/manage/deleted-file-logs"
          component={RequireAuth(DeletedFileLogs)}
        />
        {/* Imported File Logs */}
        <Route
          path="/manage/imported-file-logs"
          component={RequireAuth(ImportedFileLogs)}
        />
        {/* Workflows */}
        <Route
          path="/manage/clients/:clientId/workflows/add"
          component={RequireAuth(WorkflowAdd)}
        />
        <Route
          path="/manage/clients/:clientId/workflows/edit/:workflowId"
          component={RequireAuth(WorkflowEdit)}
        />
        <Route
          path="/manage/clients/:clientId/workflows/manage"
          component={RequireAuth(Workflows)}
        />
        {/* Uploads */}
        <Route
          path="/uploads/clients/:clientId"
          component={RequireAuth(Uploads)}
        />
        {/* Clients */}
        <Route path="/manage/clients/add" component={RequireAuth(ClientAdd)} />
        <Route
          path="/manage/clients/edit/:clientId"
          component={RequireAuth(ClientEdit)}
        />
        <Route path="/manage/clients" component={RequireAuth(Clients)} />
        <Route path="/manage/ai/add" component={RequireAuth(AiForm)} />
        <Route path="/manage/ai/edit/:id" component={RequireAuth(AiForm)} />
        <Route path="/manage/ai" component={RequireAuth(AiCredentials)} />
        <Route exact path="/manage" component={RequireAuth(Manage)} />
      </Switch>
    </Router>
  );
}
